import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.string.split";

/*
 * @Author: lijianzhang
 * @Date: 2018-11-02 14:12:15
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-09-10 11:14:05
 */
import Axios, { AxiosInstance } from 'axios';
import { compose, defaultRequest, RESTful, cache, pagination } from '@gaoding/axios-adapters';
import Qs from 'qs';
export var request = Axios.create();
export function createRequest(config) {
  var request = Axios.create(Object.assign({
    paramsSerializer: function paramsSerializer(params) {
      return Qs.stringify(params, {
        arrayFormat: 'repeat'
      });
    },
    adapter: compose(RESTful(), cache({
      enableByDefault: false
    }), pagination(), defaultRequest())
  }, config));

  request.createApi = function (apiList) {
    var api = Object.create(null);

    for (var key in apiList) {
      if (apiList.hasOwnProperty(key)) {
        (function () {
          var value = apiList[key];
          var method = 'get';
          var url = value;
          var paramsArray = value.split(' ');

          if (paramsArray.length === 2) {
            method = paramsArray[0];
            url = paramsArray[1];
          }

          api[key] = function (data, config) {
            return request.request(Object.assign({
              method,
              url,
              params: ['get', 'delete'].includes(method.toLocaleLowerCase()) ? data : null,
              data: ['get', 'delete'].includes(method.toLocaleLowerCase()) ? null : data
            }, config));
          };
        })();
      }
    }

    return api;
  };

  return request;
}